<video
  id="video-player"
  #target
  class="video-js vjs-big-play-centered vjs-theme-city"
></video>
